<template>
  <div>
    <b-form @submit="sendForm">
      <b-container class="px-0 mx-0" fluid>
        <b-row no-gutters>
          <b-col cols="12" md="6">
            <b-img src="@/static/033contacto.png" fluid class="m-0 p-0"></b-img>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group
              id="gfullname"
              :label="$t('contact_form.fullname')"
              label-for="fullname"
              class="required"
              :invalid-feedback="form_invalid_feedback.fullname"
            >
              <b-form-input
                id="fullname"
                v-model="form.fullname"
                type="text"
                autocomplete="fullname"
                required
                :placeholder="$t('contact_form.fullname')"
                :state="form_state.fullname"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="gemail"
              :label="$t('contact_form.email')"
              label-for="email"
              class="required"
              :invalid-feedback="form_invalid_feedback.email"
            >
              <b-form-input
                id="email"
                v-model="form.email"
                type="text"
                autocomplete="email"
                required
                :placeholder="$t('contact_form.email')"
                :state="form_state.email"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="gcellphone"
              :label="$t('contact_form.cellphone')"
              label-for="cellphone"
              class="required"
              :invalid-feedback="form_invalid_feedback.cellphone"
            >
              <b-form-input
                id="cellphone"
                v-model="form.cellphone"
                type="text"
                autocomplete="cellphone"
                required
                :placeholder="$t('contact_form.cellphone')"
                :state="form_state.cellphone"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="gsubject"
              :label="$t('contact_form.subject')"
              label-for="subject"
              class="required"
              :invalid-feedback="form_invalid_feedback.subject"
            >
              <b-form-input
                id="subject"
                v-model="form.subject"
                type="text"
                autocomplete="subject"
                required
                :placeholder="$t('contact_form.subject')"
                :state="form_state.subject"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              :label="$t('contact_form.message')"
              label-for="message"
            >
              <b-form-textarea
                id="message"
                v-model="form.message"
                required
                rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
      <VButtonGroup
        primary-type="submit"
        :primary_text="$t('contact_form.send_button')"
        hide_secondary
        :containerTopBorder="false"
        :marginTop="false"
        end
      />
    </b-form>
  </div>
</template>


<script>
import VButtonGroup from "@/components/VButtonGroup";
export default {
  components: { VButtonGroup },
  data() {
    return {
      form: {
        fullname: "",
        cellphone: "",
        subject: "",
        email: "",
        message: "",
      },
      form_invalid_feedback: {},
      form_state: {},
    };
  },
  methods: {
    sendForm(evt) {
      this.sending_form = true;
      evt.preventDefault();
      this.$recaptcha("contact_form").then(
        token => {
          this.$store.dispatch("naturalperson/SEND_CONTACT_FORM", {
            ...this.form,
            recaptcha_token: String(token),
          }).then(
            () => {
              this.sending_form = false;
              const successText = this.$t("contact_form.data_sent");
              this.$router.push({ name: "home" })
                .then(() => {
                  this.mnotify_success({
                    text: successText,
                  });
                });
            },
            err => {
              this.sending_form = false;
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("contact_form.error.data_not_sent"),
              });
            }
          );
        },
        err => {
          this.sending_form = false;
          this.$sentry({ capture: err });
          this.mnotify_error({
            text: this.$t("contact_form.error.data_not_sent"),
          });
        }
      );
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        contact_form: {
          subject: "Subject",
          fullname: "Full name",
          cellphone: "Contact phone",
          email: "Email",
          message: "Message",
          send_button: "Send",
          data_sent: "Your request has been sent",
          error: {
            data_not_sent: "Your request cannot be sent",
          },
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.title-container ::v-deep .title {
  color: $corp-color1;
  font-weight: 300;
}
</style>
